import { RootState } from '../reducers'

export const cartographyRealTimeMapSelector = (state: RootState, id: number) =>
  state.cartographyRealTimeMap.configs && state.cartographyRealTimeMap.configs[id] ? state.cartographyRealTimeMap.configs[id] : null

export const cartographyRealTimeMapItemsSelector = (state: RootState, id: number) =>
  state.cartographyRealTimeMap.items && state.cartographyRealTimeMap.items[id] ? state.cartographyRealTimeMap.items[id] : null
